import * as React from "react"
import "../components/general.css"
import Layout from "../components/layout"
import DisplayContact from "../components/displayContact"

const ContactPage = () => {
  return (
    <main>
      <Layout>
        <DisplayContact />
      </Layout>
    </main>
  )
}

export default ContactPage

export const Head = () => (
  <>
    <html lang="fr" />
    <title>Mobile Labs | Contactez-nous</title>
    <meta
      name="description"
      content="Contactez notre équipe d'experts en réparations de smartphones et tablettes à Riom, Auvergne. 
      Nous offrons des services de réparation rapide et fiable pour iPhone, Samsung, iPad, et plus encore. 
      Nous proposons également des services de rachat et de re-conditionnement de smartphones. Prenez rendez-vous dès aujourd'hui !"
    />
    <meta httpEquiv="Content-Security-Policy" content="frame-src 'self' https://www.google.com/ https://www.phoneshopping.fr/ https://maps.googleapis.com/;" />
    <link rel="icon" type="image/png" href="../images/logos/mobilelabs_favicon.png"></link>
  </>
)